// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2394a3b8%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2712%27 height=%2712%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2364748b%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27m6 9 6 6 6-6%27/%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ════════════════════════════════════════════════════
   GROCERY EMPTY CART
   Vespa delivery-agent — full-width left→centre→right
   ════════════════════════════════════════════════════ */
.gc-empty-root {
  display: flex;
  flex-direction: column;   /* stack lane above message */
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
  background: #ffffff;
  /* NO horizontal padding — transit lane must touch the panel edges */
  padding: 0;
  box-sizing: border-box;
  gap: 14px;
}
.gc-empty-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  width: 100%;
  padding: 0 16px;          /* horizontal padding lives here, not on root */
  box-sizing: border-box;
  /* no max-width — tip card spans the full panel width */
}

/* ── Transit lane: spans the FULL panel width, clips scooter as it enters/exits ── */
.gc-transit-lane {
  width: 100%;
  height: 180px;
  position: relative;
  overflow: hidden;
  flex-shrink: 0;
}

/* Ground shadow line */
.gc-ground {
  position: absolute;
  bottom: 10px;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(to right, transparent 0%, #e2e8f0 15%, #e2e8f0 85%, transparent 100%);
}

/* ── Scooter outer: absolute-positioned, driven by inline left + transition ── */
.gc-scooter-outer {
  position: absolute;
  bottom: 6px;
  width: 200px;
}
.gc-scooter-img {
  width: 200px;
  height: auto;
  display: block;
  user-select: none;
  -webkit-user-drag: none;
}

/* Bounce on arrival */
@keyframes gc-bounce {
  0%   { transform: translateY(0); }
  28%  { transform: translateY(-8px); }
  56%  { transform: translateY(2px); }
  76%  { transform: translateY(-3px); }
  100% { transform: translateY(0); }
}
.gc-scooter-img--bounce {
  animation: gc-bounce 0.52s ease-out;
}

/* ── Speed streaks (horizontal blur lines behind the scooter) ── */
.gc-speed-wrap {
  position: absolute;
  inset: 0;
  pointer-events: none;
}
.gc-sl {
  position: absolute;
  height: 2px;
  border-radius: 99px;
  /* gradient fades left → right, simulating motion-blur trailing leftward */
  background: linear-gradient(to right, transparent, #cbd5e1 60%, transparent);
  animation: gc-streak 0.55s linear infinite;
}
.gc-sl--1 { width: 70px;  top: 22%; left: 4%;  animation-delay: 0.00s; }
.gc-sl--2 { width: 110px; top: 38%; left: 2%;  animation-delay: 0.14s; }
.gc-sl--3 { width: 55px;  top: 55%; left: 8%;  animation-delay: 0.07s; }
.gc-sl--4 { width: 90px;  top: 70%; left: 1%;  animation-delay: 0.22s; }
.gc-sl--5 { width: 65px;  top: 84%; left: 5%;  animation-delay: 0.30s; }
@keyframes gc-streak {
  from { opacity: 0.85; transform: translateX(10px); }
  to   { opacity: 0;    transform: translateX(-30px); }
}

/* ── Text (hidden until mid-stop, then persists) ── */
.gc-empty-text {
  text-align: center;
  opacity: 0;
  transform: translateY(8px);
  transition: opacity 0.5s ease, transform 0.5s ease;
}
.gc-empty-text--in {
  opacity: 1;
  transform: translateY(0);
}
.gc-empty-title {
  margin: 0;
  font-size: 1.1rem;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: -0.02em;
  font-family: "Inter", -apple-system, sans-serif;
}
.gc-empty-sub {
  margin: 5px 0 0;
  font-size: 0.8rem;
  color: #64748b;
  font-weight: 400;
  font-family: "Inter", -apple-system, sans-serif;
  white-space: nowrap;   /* keep on one line */
}

/* ── Rotating tip (no card — plain centred text) ── */
.gc-tip-card {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  transition: opacity 0.38s ease;
  /* no background, border, or border-radius */
}
.gc-tip-icon {
  font-size: 1rem;
  line-height: 1;
  flex-shrink: 0;
}
.gc-tip-text {
  margin: 0;
  font-size: 0.775rem;
  font-weight: 500;
  color: #475569;
  line-height: 1;
  font-family: "Inter", -apple-system, sans-serif;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
}

/* ── Sponsored-by ad block — label above, logo below, centred ── */
.gc-sponsor {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 6px;
  padding: 10px 16px 14px;
  width: 100%;
  box-sizing: border-box;
}
.gc-sponsor-label {
  font-size: 0.7rem;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.10em;
  font-family: "Inter", -apple-system, sans-serif;
  white-space: nowrap;
}
.gc-sponsor-logo {
  height: 80px;
  width: auto;
  max-width: 180px;
  object-fit: contain;
  border-radius: 10px;
  flex-shrink: 0;
}

/* dark mode */
.dark .gc-sponsor-label { color: #64748b; }

/* ════════════════════════════════════════════════════ */
/* Scroll container for the cart table.
   Lives here (and not in twoWaykeyboardPaymentPage/index.css, which is never
   imported) so the rules actually reach the DOM. */
.table-wapper-modal-box-keyboard {
  font-size: 14px;
  flex: 1 1 auto;
  min-height: 0; /* without this the flex item refuses to shrink and never scrolls */
  overflow-y: auto;
  overflow-x: hidden;
  scrollbar-width: thin;
  scrollbar-color: #d1d5db transparent;
}

.table-wapper-modal-box-keyboard::-webkit-scrollbar {
  width: 6px;
  height: 6px;
  display: block;
}

.table-wapper-modal-box-keyboard::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 3px;
}

.table-wapper-modal-box-keyboard::-webkit-scrollbar-track {
  background: transparent;
}

.dark .table-wapper-modal-box-keyboard {
  background-color: #353a50;
}

#main-table-wrapper {
  width: 100%;
  border-collapse: collapse;
}

.table-tr-wrap-box {
  border-bottom: 1px solid var(--surface-g1) !important;
  border-top: none;
  border-left: none;
  border-right: none;
  font-size: 0.75rem;
  font-weight: 700;
}

#main-table-wrapper thead {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: #fff;
}

.table-th-wrapper-text {
  padding: 8px 6px;
  text-align: center;
}

.table-th-wrapper-text.item-name-grocery {
  text-align: left;
}

/* ─── Clear Cart Drawer ─────────────────────────────────── */

.clear-cart-overlay {
  position: fixed;
  inset: 0;
  z-index: 200;
  background: rgba(15, 23, 42, 0.3);
}

.clear-cart-drawer {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 1201;
  width: min(460px, 100vw);
  height: 100vh;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #fff;
  border-left: 1px solid #e2e8f0;
  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22);
  transform: translateX(100%);
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
}

.clear-cart-drawer--open {
  transform: translateX(0);
}

/* Header */
.drawer-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  border-bottom: 1px solid #f1f5f9;
  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));
  flex-shrink: 0;
}

.drawer-title {
  font-size: 1.25rem;
  font-weight: 700;
  letter-spacing: -0.025em;
  color: #0f172a;
  margin: 0;
}

.drawer-close-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  border-radius: 50%;
  border: 1px solid transparent;
  background: transparent;
  cursor: pointer;
  color: #64748b;
  transition: background 0.15s;
}

.drawer-close-btn:hover {
  background: #f1f5f9;
}

/* Body */
.drawer-body {
  flex: 1;
  overflow-y: auto;
  padding: 20px;
}

/* Icon */
.drawer-icon-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 80px;
  height: 80px;
  border-radius: 50%;
  background: #fef2f2;
  margin: 0 auto 16px;
}

.drawer-icon-svg {
  color: #ef4444;
}

/* Heading */
.drawer-heading-wrap {
  text-align: center;
  margin-bottom: 20px;
}

.drawer-heading {
  font-size: 1.125rem;
  font-weight: 600;
  color: #0f172a;
  margin: 0 0 6px;
}

.drawer-subtext {
  font-size: 0.875rem;
  line-height: 1.6;
  color: #64748b;
  margin: 0;
}

/* Form card */
.drawer-form-card {
  border-radius: 26px;
  border: 1px solid #e2e8f0;
  background: linear-gradient(180deg, #fbfdff 0%, #f8fafc 100%);
  padding: 16px;
  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.05);
  margin-bottom: 12px;
}

.drawer-field {
  margin-bottom: 16px;
}

.drawer-field:last-of-type {
  margin-bottom: 0;
}

.drawer-label {
  display: block;
  font-size: 10px;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.18em;
  color: #94a3b8;
  margin-bottom: 8px;
}

/* PIN input wrapper */
.drawer-pin-wrap {
  position: relative;
}

.drawer-pin-input {
  width: 100%;
  height: 48px;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 0 44px 0 16px;
  font-size: 0.875rem;
  color: #334155;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  outline: none;
  box-sizing: border-box;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.drawer-pin-input:focus {
  border-color: #bfdbfe;
  box-shadow: 0 0 0 4px #eff6ff;
}

.drawer-pin-toggle {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  padding: 0;
}

/* Approver card */
.drawer-approver-card {
  margin-top: 16px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.9);
  padding: 12px 16px;
  box-shadow: 0 0 0 1px #f1f5f9;
}

.drawer-approver-name {
  font-size: 0.75rem;
  font-weight: 500;
  color: #334155;
  margin: 0;
}

.drawer-approver-role {
  font-size: 0.75rem;
  color: #64748b;
  margin: 4px 0 0;
}

.drawer-helper-text {
  font-size: 0.75rem;
  color: #64748b;
  margin: 16px 0 0;
}

/* Error banner */
.drawer-error-banner {
  border-radius: 12px;
  border: 1px solid #fecaca;
  background: #fef2f2;
  padding: 12px 16px;
  font-size: 0.875rem;
  color: #dc2626;
  margin-bottom: 12px;
}

/* Actions */
.drawer-actions {
  display: flex;
  gap: 12px;
  margin-top: 12px;
}

.drawer-btn {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  height: 48px;
  border-radius: 16px;
  font-size: 0.875rem;
  font-weight: 500;
  cursor: pointer;
  border: none;
  transition:
    background 0.15s,
    box-shadow 0.15s;
}

.drawer-btn--cancel {
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #334155;
}

.drawer-btn--cancel:hover {
  background: #f8fafc;
}

.drawer-btn--confirm {
  background: #dc2626;
  color: #fff;
  box-shadow: 0 10px 24px rgba(220, 38, 38, 0.2);
}

.drawer-btn--confirm:hover:not(:disabled) {
  background: #b91c1c;
}

.drawer-btn--confirm:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.drawer-select {
  height: 2.9rem;
  border-radius: 0.9rem;
}

.drawer-select {
  margin-top: 8px;
  height: 48px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 0 16px;
  font-size: 0.875rem;
  color: #334155;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  outline: none;
  appearance: none;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-position: right 16px center;
  cursor: pointer;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
}

.drawer-select:focus {
  border-color: #bfdbfe;
  box-shadow: 0 0 0 4px #eff6ff;
}

/* this is for the options */
/* Maximize native option styling (works best in Chrome/Edge) */
.drawer-select option {
  background-color: #ffffff;
  color: #1e293b;
  font-size: 0.875rem;
  font-weight: 400;
  padding: 10px 16px; /* works in Chrome/Edge, ignored in Safari */
  line-height: 1.4;
}

.drawer-select option:hover {
  background-color: #f1f5f9 !important;
  color: #0f172a;
}

.drawer-select option:checked {
  background-color: #eff6ff;
  color: #1e40af;
  font-weight: 500;
}

.drawer-select option:first-of-type {
  color: #64748b;
  font-style: italic;
}

/* Increase dropdown height to show more options */
.drawer-select {
  /* already there */
  size: 5; /* but this breaks the normal select behavior, don't add */
}

.custom-select-trigger {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 48px;
  width: 100%;
  border-radius: 16px;
  border: 1px solid #e2e8f0;
  background: #fff;
  padding: 0 16px;
  font-size: 0.875rem;
  color: #334155;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  cursor: pointer;
  transition:
    border-color 0.15s,
    box-shadow 0.15s;
  box-sizing: border-box;
  margin-top: 8px;
}

.custom-select-trigger.open {
  border-color: #bfdbfe;
  box-shadow: 0 0 0 4px #eff6ff;
}

.custom-select-trigger span {
  color: black !important;
  font-style: normal;
  font-size: 14px;
  font-weight: 300;
}

.custom-select-options {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  right: 0;
  z-index: 999;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);
  padding: 6px;
  margin: 0;
  list-style: none;
  max-height: 200px;
  overflow-y: auto;
}

.custom-option {
  padding: 10px 16px;
  font-size: 0.875rem;
  color: #1e293b;
  border-radius: 10px;
  cursor: pointer;
  transition: background 0.12s;
}

.custom-option:hover {
  background: #f1f5f9;
  color: #0f172a;
}

.custom-option.selected {
  background: #eff6ff;
  color: #1e40af;
  font-weight: 500;
}

/* ════════════════════════════════════════════════════
   DARK THEME
   ════════════════════════════════════════════════════ */

/* Empty cart */
.dark .gc-empty-root {
  background: #0f172a;
}
.dark .gc-empty-title {
  color: #f1f5f9;
}
.dark .gc-empty-sub {
  color: #94a3b8;
}
.dark .gc-tip-card {
  background: #1e293b;
  border-color: #334155;
}
.dark .gc-tip-text {
  color: #94a3b8;
}

/* Cart table */
.dark #main-table-wrapper thead {
  background-color: #1e293b;
}
.dark .table-tr-wrap-box {
  border-color: #334155 !important;
  color: #e2e8f0;
}
.dark .table-th-wrapper-text {
  color: #94a3b8;
}

/* Clear-cart drawer */
.dark .clear-cart-drawer {
  background: #1e293b;
  border-color: #334155;
}
.dark .drawer-header {
  background: linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(15, 23, 42, 0.95));
  border-bottom-color: #334155;
}
.dark .drawer-title {
  color: #f1f5f9;
}
.dark .drawer-close-btn {
  color: #94a3b8;
}
.dark .drawer-close-btn:hover {
  background: #334155;
}
.dark .drawer-heading {
  color: #f1f5f9;
}
.dark .drawer-subtext {
  color: #94a3b8;
}
.dark .drawer-label {
  color: #64748b;
}
.dark .drawer-form-card {
  background: linear-gradient(180deg, #1e293b 0%, #162032 100%);
  border-color: #334155;
  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.3);
}
.dark .drawer-pin-input {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
  box-shadow: none;
}
.dark .drawer-pin-input:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}
.dark .drawer-pin-toggle {
  color: #64748b;
}
.dark .drawer-approver-card {
  background: rgba(15, 23, 42, 0.6);
  box-shadow: 0 0 0 1px #334155;
}
.dark .drawer-approver-name {
  color: #e2e8f0;
}
.dark .drawer-approver-role {
  color: #94a3b8;
}
.dark .drawer-helper-text {
  color: #64748b;
}
.dark .drawer-select {
  background-color: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.dark .drawer-select:focus {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}
.dark .drawer-select option {
  background-color: #1e293b;
  color: #e2e8f0;
}
.dark .custom-select-trigger {
  background: #0f172a;
  border-color: #334155;
  color: #e2e8f0;
}
.dark .custom-select-trigger span {
  color: #e2e8f0 !important;
}
.dark .custom-select-trigger.open {
  border-color: #3b82f6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);
}
.dark .custom-select-options {
  background: #1e293b;
  border-color: #334155;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);
}
.dark .custom-option {
  color: #e2e8f0;
}
.dark .custom-option:hover {
  background: #334155;
  color: #f1f5f9;
}
.dark .custom-option.selected {
  background: rgba(59, 130, 246, 0.18);
  color: #93c5fd;
}
.dark .drawer-btn--cancel {
  background: #1e293b;
  border-color: #334155;
  color: #cbd5e1;
}
.dark .drawer-btn--cancel:hover {
  background: #334155;
}

/* Bundle group header */
.dark .cart-bundle-group-header-inner {
  background: linear-gradient(90deg, #1e3a5f 0%, #1e293b 100%);
  border-left-color: #3b82f6;
  border-top-color: #1e3a5f;
  border-bottom-color: #1e3a5f;
}
.dark .cart-bundle-group-name {
  color: #93c5fd;
}
.dark .cart-bundle-group-badge {
  color: #60a5fa;
  background: rgba(59, 130, 246, 0.2);
}
.dark .cart-bundle-group-sp {
  color: #e2e8f0;
}

/* ── Bundle group header row in cart ── */
.cart-bundle-group-header-tbody {
  position: relative;
}

.cart-bundle-group-header-row td {
  padding: 0;
  border-bottom: none;
}

.cart-bundle-group-header-inner {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 6px 12px;
  background: linear-gradient(90deg, #eff6ff 0%, #f8fbff 100%);
  border-left: 3px solid #2a71ff;
  border-top: 1px solid #dbeafe;
  border-bottom: 1px solid #dbeafe;
}

.cart-bundle-group-name {
  font-size: 11px;
  font-weight: 700;
  color: #1e40af;
  letter-spacing: 0.02em;
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.cart-bundle-group-badge {
  font-size: 10px;
  font-weight: 700;
  color: #2a71ff;
  background: #dbeafe;
  border-radius: 99px;
  padding: 1px 8px;
  white-space: nowrap;
}

.cart-bundle-group-sp {
  font-size: 11px;
  font-weight: 700;
  color: #0f172a;
  white-space: nowrap;
  margin-left: auto;
}
`, "",{"version":3,"sources":["webpack://./client/src/layouts/ecommerce/product/all-products/components/tabModal/tabmodal6/index.css"],"names":[],"mappings":"AAAA;;;yDAGyD;AACzD;EACE,aAAa;EACb,sBAAsB,IAAI,6BAA6B;EACvD,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,oEAAoE;EACpE,UAAU;EACV,sBAAsB;EACtB,SAAS;AACX;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,WAAW;EACX,eAAe,WAAW,+CAA+C;EACzE,sBAAsB;EACtB,uDAAuD;AACzD;;AAEA,qFAAqF;AACrF;EACE,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,uBAAuB;AACvB;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,QAAQ;EACR,WAAW;EACX,iGAAiG;AACnG;;AAEA,iFAAiF;AACjF;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA,sBAAsB;AACtB;EACE,OAAO,wBAAwB,EAAE;EACjC,OAAO,2BAA2B,EAAE;EACpC,OAAO,0BAA0B,EAAE;EACnC,OAAO,2BAA2B,EAAE;EACpC,OAAO,wBAAwB,EAAE;AACnC;AACA;EACE,mCAAmC;AACrC;;AAEA,mEAAmE;AACnE;EACE,kBAAkB;EAClB,QAAQ;EACR,oBAAoB;AACtB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,mBAAmB;EACnB,0EAA0E;EAC1E,4EAA4E;EAC5E,0CAA0C;AAC5C;AACA,YAAY,WAAW,GAAG,QAAQ,EAAE,QAAQ,GAAG,sBAAsB,EAAE;AACvE,YAAY,YAAY,EAAE,QAAQ,EAAE,QAAQ,GAAG,sBAAsB,EAAE;AACvE,YAAY,WAAW,GAAG,QAAQ,EAAE,QAAQ,GAAG,sBAAsB,EAAE;AACvE,YAAY,WAAW,GAAG,QAAQ,EAAE,QAAQ,GAAG,sBAAsB,EAAE;AACvE,YAAY,WAAW,GAAG,QAAQ,EAAE,QAAQ,GAAG,sBAAsB,EAAE;AACvE;EACE,OAAO,aAAa,EAAE,2BAA2B,EAAE;EACnD,OAAO,UAAU,KAAK,4BAA4B,EAAE;AACtD;;AAEA,sDAAsD;AACtD;EACE,kBAAkB;EAClB,UAAU;EACV,0BAA0B;EAC1B,kDAAkD;AACpD;AACA;EACE,UAAU;EACV,wBAAwB;AAC1B;AACA;EACE,SAAS;EACT,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,+CAA+C;AACjD;AACA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,gBAAgB;EAChB,+CAA+C;EAC/C,mBAAmB,IAAI,qBAAqB;AAC9C;;AAEA,sDAAsD;AACtD;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,4CAA4C;AAC9C;AACA;EACE,eAAe;EACf,cAAc;EACd,cAAc;AAChB;AACA;EACE,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,cAAc;EACd,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA,mEAAmE;AACnE;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,QAAQ;EACR,uBAAuB;EACvB,WAAW;EACX,sBAAsB;AACxB;AACA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,+CAA+C;EAC/C,mBAAmB;AACrB;AACA;EACE,YAAY;EACZ,WAAW;EACX,gBAAgB;EAChB,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA,cAAc;AACd,0BAA0B,cAAc,EAAE;;AAE1C,yDAAyD;AACzD;;mDAEmD;AACnD;EACE,eAAe;EACf,cAAc;EACd,aAAa,EAAE,mEAAmE;EAClF,gBAAgB;EAChB,kBAAkB;EAClB,qBAAqB;EACrB,oCAAoC;AACtC;;AAEA;EACE,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA,8DAA8D;;AAE9D;EACE,eAAe;EACf,QAAQ;EACR,YAAY;EACZ,iCAAiC;AACnC;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,SAAS;EACT,aAAa;EACb,wBAAwB;EACxB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,gBAAgB;EAChB,8BAA8B;EAC9B,8CAA8C;EAC9C,2BAA2B;EAC3B,uDAAuD;AACzD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA,WAAW;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,gCAAgC;EAChC,yFAAyF;EACzF,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,uBAAuB;EACvB,eAAe;EACf,cAAc;EACd,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,OAAO;EACP,gBAAgB;EAChB,aAAa;AACf;;AAEA,SAAS;AACT;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA,cAAc;AACd;EACE,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D,aAAa;EACb,8CAA8C;EAC9C,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,kBAAkB;AACpB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,aAAa;EACb,sBAAsB;EACtB;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,UAAU;AACZ;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,mBAAmB;EACnB,oCAAoC;EACpC,kBAAkB;EAClB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ;;oBAEkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,yDAAwQ;EACxQ,4BAA4B;EAC5B,sCAAsC;EACtC,eAAe;EACf;;oBAEkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA,4BAA4B;AAC5B,+DAA+D;AAC/D;EACE,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB,EAAE,4CAA4C;EAChE,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA,kDAAkD;AAClD;EACE,kBAAkB;EAClB,OAAO,EAAE,0DAA0D;AACrE;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,WAAW;EACX,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,yCAAyC;EACzC,eAAe;EACf;;oBAEkB;EAClB,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,6BAA6B;AAC/B;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,OAAO;EACP,QAAQ;EACR,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;EAC7C,YAAY;EACZ,SAAS;EACT,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,4BAA4B;AAC9B;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,gBAAgB;AAClB;;AAEA;;yDAEyD;;AAEzD,eAAe;AACf;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,cAAc;AAChB;;AAEA,eAAe;AACf;EACE,yBAAyB;AAC3B;AACA;EACE,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,mBAAmB;EACnB,qBAAqB;AACvB;AACA;EACE,mFAAmF;EACnF,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,6DAA6D;EAC7D,qBAAqB;EACrB,0CAA0C;AAC5C;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,6BAA6B;AAC/B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,qBAAqB;EACrB,cAAc;EACd,yDAAwQ;AAC1Q;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,yBAAyB;EACzB,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,qBAAqB;EACrB,8CAA8C;AAChD;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,yCAAyC;AAC3C;AACA;EACE,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,oCAAoC;EACpC,cAAc;AAChB;AACA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,cAAc;AAChB;AACA;EACE,mBAAmB;AACrB;;AAEA,wBAAwB;AACxB;EACE,4DAA4D;EAC5D,0BAA0B;EAC1B,yBAAyB;EACzB,4BAA4B;AAC9B;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,mCAAmC;AACrC;AACA;EACE,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,4DAA4D;EAC5D,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;AAClC;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,sBAAsB;EACtB,OAAO;EACP,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":["/* ════════════════════════════════════════════════════\n   GROCERY EMPTY CART\n   Vespa delivery-agent — full-width left→centre→right\n   ════════════════════════════════════════════════════ */\n.gc-empty-root {\n  display: flex;\n  flex-direction: column;   /* stack lane above message */\n  align-items: center;\n  justify-content: center;\n  height: 100%;\n  width: 100%;\n  background: #ffffff;\n  /* NO horizontal padding — transit lane must touch the panel edges */\n  padding: 0;\n  box-sizing: border-box;\n  gap: 14px;\n}\n.gc-empty-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  width: 100%;\n  padding: 0 16px;          /* horizontal padding lives here, not on root */\n  box-sizing: border-box;\n  /* no max-width — tip card spans the full panel width */\n}\n\n/* ── Transit lane: spans the FULL panel width, clips scooter as it enters/exits ── */\n.gc-transit-lane {\n  width: 100%;\n  height: 180px;\n  position: relative;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n/* Ground shadow line */\n.gc-ground {\n  position: absolute;\n  bottom: 10px;\n  left: 0;\n  right: 0;\n  height: 3px;\n  background: linear-gradient(to right, transparent 0%, #e2e8f0 15%, #e2e8f0 85%, transparent 100%);\n}\n\n/* ── Scooter outer: absolute-positioned, driven by inline left + transition ── */\n.gc-scooter-outer {\n  position: absolute;\n  bottom: 6px;\n  width: 200px;\n}\n.gc-scooter-img {\n  width: 200px;\n  height: auto;\n  display: block;\n  user-select: none;\n  -webkit-user-drag: none;\n}\n\n/* Bounce on arrival */\n@keyframes gc-bounce {\n  0%   { transform: translateY(0); }\n  28%  { transform: translateY(-8px); }\n  56%  { transform: translateY(2px); }\n  76%  { transform: translateY(-3px); }\n  100% { transform: translateY(0); }\n}\n.gc-scooter-img--bounce {\n  animation: gc-bounce 0.52s ease-out;\n}\n\n/* ── Speed streaks (horizontal blur lines behind the scooter) ── */\n.gc-speed-wrap {\n  position: absolute;\n  inset: 0;\n  pointer-events: none;\n}\n.gc-sl {\n  position: absolute;\n  height: 2px;\n  border-radius: 99px;\n  /* gradient fades left → right, simulating motion-blur trailing leftward */\n  background: linear-gradient(to right, transparent, #cbd5e1 60%, transparent);\n  animation: gc-streak 0.55s linear infinite;\n}\n.gc-sl--1 { width: 70px;  top: 22%; left: 4%;  animation-delay: 0.00s; }\n.gc-sl--2 { width: 110px; top: 38%; left: 2%;  animation-delay: 0.14s; }\n.gc-sl--3 { width: 55px;  top: 55%; left: 8%;  animation-delay: 0.07s; }\n.gc-sl--4 { width: 90px;  top: 70%; left: 1%;  animation-delay: 0.22s; }\n.gc-sl--5 { width: 65px;  top: 84%; left: 5%;  animation-delay: 0.30s; }\n@keyframes gc-streak {\n  from { opacity: 0.85; transform: translateX(10px); }\n  to   { opacity: 0;    transform: translateX(-30px); }\n}\n\n/* ── Text (hidden until mid-stop, then persists) ── */\n.gc-empty-text {\n  text-align: center;\n  opacity: 0;\n  transform: translateY(8px);\n  transition: opacity 0.5s ease, transform 0.5s ease;\n}\n.gc-empty-text--in {\n  opacity: 1;\n  transform: translateY(0);\n}\n.gc-empty-title {\n  margin: 0;\n  font-size: 1.1rem;\n  font-weight: 700;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  font-family: \"Inter\", -apple-system, sans-serif;\n}\n.gc-empty-sub {\n  margin: 5px 0 0;\n  font-size: 0.8rem;\n  color: #64748b;\n  font-weight: 400;\n  font-family: \"Inter\", -apple-system, sans-serif;\n  white-space: nowrap;   /* keep on one line */\n}\n\n/* ── Rotating tip (no card — plain centred text) ── */\n.gc-tip-card {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  width: 100%;\n  box-sizing: border-box;\n  transition: opacity 0.38s ease;\n  /* no background, border, or border-radius */\n}\n.gc-tip-icon {\n  font-size: 1rem;\n  line-height: 1;\n  flex-shrink: 0;\n}\n.gc-tip-text {\n  margin: 0;\n  font-size: 0.775rem;\n  font-weight: 500;\n  color: #475569;\n  line-height: 1;\n  font-family: \"Inter\", -apple-system, sans-serif;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n}\n\n/* ── Sponsored-by ad block — label above, logo below, centred ── */\n.gc-sponsor {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 6px;\n  padding: 10px 16px 14px;\n  width: 100%;\n  box-sizing: border-box;\n}\n.gc-sponsor-label {\n  font-size: 0.7rem;\n  font-weight: 600;\n  color: #94a3b8;\n  text-transform: uppercase;\n  letter-spacing: 0.10em;\n  font-family: \"Inter\", -apple-system, sans-serif;\n  white-space: nowrap;\n}\n.gc-sponsor-logo {\n  height: 80px;\n  width: auto;\n  max-width: 180px;\n  object-fit: contain;\n  border-radius: 10px;\n  flex-shrink: 0;\n}\n\n/* dark mode */\n.dark .gc-sponsor-label { color: #64748b; }\n\n/* ════════════════════════════════════════════════════ */\n/* Scroll container for the cart table.\n   Lives here (and not in twoWaykeyboardPaymentPage/index.css, which is never\n   imported) so the rules actually reach the DOM. */\n.table-wapper-modal-box-keyboard {\n  font-size: 14px;\n  flex: 1 1 auto;\n  min-height: 0; /* without this the flex item refuses to shrink and never scrolls */\n  overflow-y: auto;\n  overflow-x: hidden;\n  scrollbar-width: thin;\n  scrollbar-color: #d1d5db transparent;\n}\n\n.table-wapper-modal-box-keyboard::-webkit-scrollbar {\n  width: 6px;\n  height: 6px;\n  display: block;\n}\n\n.table-wapper-modal-box-keyboard::-webkit-scrollbar-thumb {\n  background-color: #d1d5db;\n  border-radius: 3px;\n}\n\n.table-wapper-modal-box-keyboard::-webkit-scrollbar-track {\n  background: transparent;\n}\n\n.dark .table-wapper-modal-box-keyboard {\n  background-color: #353a50;\n}\n\n#main-table-wrapper {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.table-tr-wrap-box {\n  border-bottom: 1px solid var(--surface-g1) !important;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n  font-size: 0.75rem;\n  font-weight: 700;\n}\n\n#main-table-wrapper thead {\n  position: sticky;\n  top: 0;\n  z-index: 10;\n  background-color: #fff;\n}\n\n.table-th-wrapper-text {\n  padding: 8px 6px;\n  text-align: center;\n}\n\n.table-th-wrapper-text.item-name-grocery {\n  text-align: left;\n}\n\n/* ─── Clear Cart Drawer ─────────────────────────────────── */\n\n.clear-cart-overlay {\n  position: fixed;\n  inset: 0;\n  z-index: 200;\n  background: rgba(15, 23, 42, 0.3);\n}\n\n.clear-cart-drawer {\n  position: fixed;\n  top: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1201;\n  width: min(460px, 100vw);\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  background: #fff;\n  border-left: 1px solid #e2e8f0;\n  box-shadow: 0 32px 90px rgba(15, 23, 42, 0.22);\n  transform: translateX(100%);\n  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n\n.clear-cart-drawer--open {\n  transform: translateX(0);\n}\n\n/* Header */\n.drawer-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 16px 20px;\n  border-bottom: 1px solid #f1f5f9;\n  background: linear-gradient(135deg, rgba(255, 251, 235, 0.96), rgba(255, 255, 255, 0.92));\n  flex-shrink: 0;\n}\n\n.drawer-title {\n  font-size: 1.25rem;\n  font-weight: 700;\n  letter-spacing: -0.025em;\n  color: #0f172a;\n  margin: 0;\n}\n\n.drawer-close-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 36px;\n  height: 36px;\n  border-radius: 50%;\n  border: 1px solid transparent;\n  background: transparent;\n  cursor: pointer;\n  color: #64748b;\n  transition: background 0.15s;\n}\n\n.drawer-close-btn:hover {\n  background: #f1f5f9;\n}\n\n/* Body */\n.drawer-body {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n}\n\n/* Icon */\n.drawer-icon-wrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 80px;\n  height: 80px;\n  border-radius: 50%;\n  background: #fef2f2;\n  margin: 0 auto 16px;\n}\n\n.drawer-icon-svg {\n  color: #ef4444;\n}\n\n/* Heading */\n.drawer-heading-wrap {\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.drawer-heading {\n  font-size: 1.125rem;\n  font-weight: 600;\n  color: #0f172a;\n  margin: 0 0 6px;\n}\n\n.drawer-subtext {\n  font-size: 0.875rem;\n  line-height: 1.6;\n  color: #64748b;\n  margin: 0;\n}\n\n/* Form card */\n.drawer-form-card {\n  border-radius: 26px;\n  border: 1px solid #e2e8f0;\n  background: linear-gradient(180deg, #fbfdff 0%, #f8fafc 100%);\n  padding: 16px;\n  box-shadow: 0 14px 30px rgba(15, 23, 42, 0.05);\n  margin-bottom: 12px;\n}\n\n.drawer-field {\n  margin-bottom: 16px;\n}\n\n.drawer-field:last-of-type {\n  margin-bottom: 0;\n}\n\n.drawer-label {\n  display: block;\n  font-size: 10px;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.18em;\n  color: #94a3b8;\n  margin-bottom: 8px;\n}\n\n/* PIN input wrapper */\n.drawer-pin-wrap {\n  position: relative;\n}\n\n.drawer-pin-input {\n  width: 100%;\n  height: 48px;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 0 44px 0 16px;\n  font-size: 0.875rem;\n  color: #334155;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  outline: none;\n  box-sizing: border-box;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.drawer-pin-input:focus {\n  border-color: #bfdbfe;\n  box-shadow: 0 0 0 4px #eff6ff;\n}\n\n.drawer-pin-toggle {\n  position: absolute;\n  right: 12px;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  padding: 0;\n}\n\n/* Approver card */\n.drawer-approver-card {\n  margin-top: 16px;\n  border-radius: 20px;\n  background: rgba(255, 255, 255, 0.9);\n  padding: 12px 16px;\n  box-shadow: 0 0 0 1px #f1f5f9;\n}\n\n.drawer-approver-name {\n  font-size: 0.75rem;\n  font-weight: 500;\n  color: #334155;\n  margin: 0;\n}\n\n.drawer-approver-role {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin: 4px 0 0;\n}\n\n.drawer-helper-text {\n  font-size: 0.75rem;\n  color: #64748b;\n  margin: 16px 0 0;\n}\n\n/* Error banner */\n.drawer-error-banner {\n  border-radius: 12px;\n  border: 1px solid #fecaca;\n  background: #fef2f2;\n  padding: 12px 16px;\n  font-size: 0.875rem;\n  color: #dc2626;\n  margin-bottom: 12px;\n}\n\n/* Actions */\n.drawer-actions {\n  display: flex;\n  gap: 12px;\n  margin-top: 12px;\n}\n\n.drawer-btn {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  flex: 1;\n  height: 48px;\n  border-radius: 16px;\n  font-size: 0.875rem;\n  font-weight: 500;\n  cursor: pointer;\n  border: none;\n  transition:\n    background 0.15s,\n    box-shadow 0.15s;\n}\n\n.drawer-btn--cancel {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  color: #334155;\n}\n\n.drawer-btn--cancel:hover {\n  background: #f8fafc;\n}\n\n.drawer-btn--confirm {\n  background: #dc2626;\n  color: #fff;\n  box-shadow: 0 10px 24px rgba(220, 38, 38, 0.2);\n}\n\n.drawer-btn--confirm:hover:not(:disabled) {\n  background: #b91c1c;\n}\n\n.drawer-btn--confirm:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.drawer-select {\n  height: 2.9rem;\n  border-radius: 0.9rem;\n}\n\n.drawer-select {\n  margin-top: 8px;\n  height: 48px;\n  width: 100%;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 0 16px;\n  font-size: 0.875rem;\n  color: #334155;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  outline: none;\n  appearance: none;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2394a3b8' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n  background-repeat: no-repeat;\n  background-position: right 16px center;\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n}\n\n.drawer-select:focus {\n  border-color: #bfdbfe;\n  box-shadow: 0 0 0 4px #eff6ff;\n}\n\n/* this is for the options */\n/* Maximize native option styling (works best in Chrome/Edge) */\n.drawer-select option {\n  background-color: #ffffff;\n  color: #1e293b;\n  font-size: 0.875rem;\n  font-weight: 400;\n  padding: 10px 16px; /* works in Chrome/Edge, ignored in Safari */\n  line-height: 1.4;\n}\n\n.drawer-select option:hover {\n  background-color: #f1f5f9 !important;\n  color: #0f172a;\n}\n\n.drawer-select option:checked {\n  background-color: #eff6ff;\n  color: #1e40af;\n  font-weight: 500;\n}\n\n.drawer-select option:first-of-type {\n  color: #64748b;\n  font-style: italic;\n}\n\n/* Increase dropdown height to show more options */\n.drawer-select {\n  /* already there */\n  size: 5; /* but this breaks the normal select behavior, don't add */\n}\n\n.custom-select-trigger {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: 48px;\n  width: 100%;\n  border-radius: 16px;\n  border: 1px solid #e2e8f0;\n  background: #fff;\n  padding: 0 16px;\n  font-size: 0.875rem;\n  color: #334155;\n  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);\n  cursor: pointer;\n  transition:\n    border-color 0.15s,\n    box-shadow 0.15s;\n  box-sizing: border-box;\n  margin-top: 8px;\n}\n\n.custom-select-trigger.open {\n  border-color: #bfdbfe;\n  box-shadow: 0 0 0 4px #eff6ff;\n}\n\n.custom-select-trigger span {\n  color: black !important;\n  font-style: normal;\n  font-size: 14px;\n  font-weight: 300;\n}\n\n.custom-select-options {\n  position: absolute;\n  top: calc(100% + 4px);\n  left: 0;\n  right: 0;\n  z-index: 999;\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 16px;\n  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.12);\n  padding: 6px;\n  margin: 0;\n  list-style: none;\n  max-height: 200px;\n  overflow-y: auto;\n}\n\n.custom-option {\n  padding: 10px 16px;\n  font-size: 0.875rem;\n  color: #1e293b;\n  border-radius: 10px;\n  cursor: pointer;\n  transition: background 0.12s;\n}\n\n.custom-option:hover {\n  background: #f1f5f9;\n  color: #0f172a;\n}\n\n.custom-option.selected {\n  background: #eff6ff;\n  color: #1e40af;\n  font-weight: 500;\n}\n\n/* ════════════════════════════════════════════════════\n   DARK THEME\n   ════════════════════════════════════════════════════ */\n\n/* Empty cart */\n.dark .gc-empty-root {\n  background: #0f172a;\n}\n.dark .gc-empty-title {\n  color: #f1f5f9;\n}\n.dark .gc-empty-sub {\n  color: #94a3b8;\n}\n.dark .gc-tip-card {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .gc-tip-text {\n  color: #94a3b8;\n}\n\n/* Cart table */\n.dark #main-table-wrapper thead {\n  background-color: #1e293b;\n}\n.dark .table-tr-wrap-box {\n  border-color: #334155 !important;\n  color: #e2e8f0;\n}\n.dark .table-th-wrapper-text {\n  color: #94a3b8;\n}\n\n/* Clear-cart drawer */\n.dark .clear-cart-drawer {\n  background: #1e293b;\n  border-color: #334155;\n}\n.dark .drawer-header {\n  background: linear-gradient(135deg, rgba(30, 41, 59, 0.98), rgba(15, 23, 42, 0.95));\n  border-bottom-color: #334155;\n}\n.dark .drawer-title {\n  color: #f1f5f9;\n}\n.dark .drawer-close-btn {\n  color: #94a3b8;\n}\n.dark .drawer-close-btn:hover {\n  background: #334155;\n}\n.dark .drawer-heading {\n  color: #f1f5f9;\n}\n.dark .drawer-subtext {\n  color: #94a3b8;\n}\n.dark .drawer-label {\n  color: #64748b;\n}\n.dark .drawer-form-card {\n  background: linear-gradient(180deg, #1e293b 0%, #162032 100%);\n  border-color: #334155;\n  box-shadow: 0 14px 30px rgba(0, 0, 0, 0.3);\n}\n.dark .drawer-pin-input {\n  background: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n  box-shadow: none;\n}\n.dark .drawer-pin-input:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n.dark .drawer-pin-toggle {\n  color: #64748b;\n}\n.dark .drawer-approver-card {\n  background: rgba(15, 23, 42, 0.6);\n  box-shadow: 0 0 0 1px #334155;\n}\n.dark .drawer-approver-name {\n  color: #e2e8f0;\n}\n.dark .drawer-approver-role {\n  color: #94a3b8;\n}\n.dark .drawer-helper-text {\n  color: #64748b;\n}\n.dark .drawer-select {\n  background-color: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='12' viewBox='0 0 24 24' fill='none' stroke='%2364748b' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E\");\n}\n.dark .drawer-select:focus {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n.dark .drawer-select option {\n  background-color: #1e293b;\n  color: #e2e8f0;\n}\n.dark .custom-select-trigger {\n  background: #0f172a;\n  border-color: #334155;\n  color: #e2e8f0;\n}\n.dark .custom-select-trigger span {\n  color: #e2e8f0 !important;\n}\n.dark .custom-select-trigger.open {\n  border-color: #3b82f6;\n  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.15);\n}\n.dark .custom-select-options {\n  background: #1e293b;\n  border-color: #334155;\n  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.4);\n}\n.dark .custom-option {\n  color: #e2e8f0;\n}\n.dark .custom-option:hover {\n  background: #334155;\n  color: #f1f5f9;\n}\n.dark .custom-option.selected {\n  background: rgba(59, 130, 246, 0.18);\n  color: #93c5fd;\n}\n.dark .drawer-btn--cancel {\n  background: #1e293b;\n  border-color: #334155;\n  color: #cbd5e1;\n}\n.dark .drawer-btn--cancel:hover {\n  background: #334155;\n}\n\n/* Bundle group header */\n.dark .cart-bundle-group-header-inner {\n  background: linear-gradient(90deg, #1e3a5f 0%, #1e293b 100%);\n  border-left-color: #3b82f6;\n  border-top-color: #1e3a5f;\n  border-bottom-color: #1e3a5f;\n}\n.dark .cart-bundle-group-name {\n  color: #93c5fd;\n}\n.dark .cart-bundle-group-badge {\n  color: #60a5fa;\n  background: rgba(59, 130, 246, 0.2);\n}\n.dark .cart-bundle-group-sp {\n  color: #e2e8f0;\n}\n\n/* ── Bundle group header row in cart ── */\n.cart-bundle-group-header-tbody {\n  position: relative;\n}\n\n.cart-bundle-group-header-row td {\n  padding: 0;\n  border-bottom: none;\n}\n\n.cart-bundle-group-header-inner {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 12px;\n  background: linear-gradient(90deg, #eff6ff 0%, #f8fbff 100%);\n  border-left: 3px solid #2a71ff;\n  border-top: 1px solid #dbeafe;\n  border-bottom: 1px solid #dbeafe;\n}\n\n.cart-bundle-group-name {\n  font-size: 11px;\n  font-weight: 700;\n  color: #1e40af;\n  letter-spacing: 0.02em;\n  flex: 1;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.cart-bundle-group-badge {\n  font-size: 10px;\n  font-weight: 700;\n  color: #2a71ff;\n  background: #dbeafe;\n  border-radius: 99px;\n  padding: 1px 8px;\n  white-space: nowrap;\n}\n\n.cart-bundle-group-sp {\n  font-size: 11px;\n  font-weight: 700;\n  color: #0f172a;\n  white-space: nowrap;\n  margin-left: auto;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
